<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount} from 'svelte';
    import {fade} from 'svelte/transition';
    import {paginate} from '../common/pagination.js';
    import {validateForm} from '../Form/utils.js';
    import {submit} from '../Form/utils.js';
    import Button from '../Button.svelte';
    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import Errors from '../Errors.svelte';
    import Modal from '../Modal.svelte'
    import TextInput from '../TextInput.svelte';
    import DataTable from '../DataGrid/DataTable.svelte';
    import DateTimeColumn from '../DataGrid/ColumnRenderers/DateTimeColumn.svelte';
    import ActivityVersionColumn from './ElementView/ColumnRenderers/ActivityVersionColumn.svelte';
    import IssueColumn from './ElementView/ColumnRenderers/IssueColumn.svelte';
    import {elementDetails, standaloneEdit, activityVersion, elementInstance, branchId} from './workspacesStore.js';
    import {elementTabs} from '../Workspaces/tabStore.js';
    import {object, number, string} from 'yup';

    import {get} from '../../utils.js';
    import {sgettext} from '../../i18n';

    let activityDetails = $activityVersion;
    let instanceDetails = $elementInstance;
    let branch = $branchId;
    export let details = $elementDetails;
    $: if($elementDetails){
        details = $elementDetails;
        activityDetails = $activityVersion;
        instanceDetails = $elementInstance;
        getIssues();
        resetForm();
    }

    let loading = false;
    let draftVersionNumber = 0;

    let PER_PAGE = 10;

    let showRaiseImprovement = activityDetails ? true : false;
    let formErrors = null;
    let id = 'raise_improvement';
    let title = sgettext('$$NEW_IMPROVEMENT$$');
    let classificationApi = `${PATH_PREFIX}/sw/api/issue_classifications`;
    let improvementApi = `${PATH_PREFIX}/sw/api/improvement/`;
    let improvementPossibleMatchesApi = `${PATH_PREFIX}/sw/api/improvement/possible_matches/`;
    let issueClassificationTypes = [];
    let jiraStatus = false;
    let newImprovement = getDefault();

    let data = {
        'columns': {
            created_date: {
                label: sgettext('$$DATE_REPORTED$$'),
                renderer: DateTimeColumn
            },
            description: {
                label: sgettext('$$DESCRIPTION$$'),
                renderer: IssueColumn,
            },
            activity_version: {
                label: sgettext('$$ACTIVITY_1$$'),
                renderer: ActivityVersionColumn,
            },
            element_version_number: {
                label: sgettext('$$ELEMENT_VERSION$$')
            },
            status: {
                label: sgettext('$$STATUS$$')
            }

        },
        'rows': [],
        'page': [],
        'per_page': PER_PAGE,
    };

    let draftElementVersionViewApiUrl = `${PATH_PREFIX}/sw/api/elements_database/draft_element_version/`;

    async function getIssues() {
        const eevId = $elementDetails ? $elementDetails.eevId : 0;

        if (eevId) {
            loading = true;
            const issuesResponse = await get(`${PATH_PREFIX}/sw/api/elements_database/element_version/${eevId}/element-issues/`);
            if (issuesResponse.ok) {
                data.rows = await issuesResponse.json();
                data.page = paginate(data.rows, data.per_page, 1);
                const activeTab = $elementTabs.find(t => t.key === 'issues');
                const numOpenIssues = data.rows.filter(x => x.status === 'OPEN').length;
                activeTab.label = `${sgettext('$$IMPROVEMENTS$$')} (${numOpenIssues})`;
                elementTabs.set([...$elementTabs]);
            }
            loading = false;
        }
    }

    function getDefault() {
        return {
            activity_version: showRaiseImprovement ? activityDetails.id : null,
            element_instance: instanceDetails.id,
            work_sequence: instanceDetails.worksequenceId,
            activity: showRaiseImprovement ? activityDetails.activity_id : null,
            classification: null,
            value: '',
            create_in_jira: false,
        };
    }

    async function getClassifications() {
        const resp = await get(classificationApi);
        const json = await resp.json();
        const result = json['results'];
        issueClassificationTypes = [...result.map(x => ({id: x.id, name: `${sgettext(x.classification_name)}`}))];
        if (issue.classification_id > 0) {
            newImprovement.classification = issue.classification_id;
        } else {
            newImprovement.classification = 0;
        }
    }

    function getDefaultFieldIsValid() {
        return {
            create_in_jira: {
                isValid: true,
                errors: '',
            },
            classification: {
                isValid: true,
                errors: '',
            },
            value: {
                isValid: true,
                errors: '',
            },
        };
    }

    let fieldIsValid = getDefaultFieldIsValid();

    let schema = object().shape({
        classification: number()
            .test('val', sgettext('$$REQUIRED_FIELD$$'), val => val > 0)
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
        value: string()
            .test('len', sgettext('$$CANNOT_EXCEED_1024_CHARACTERS$$'), val => val.length <= 1024)
            .test('len', sgettext('$$SUMMARY_REQUIRED_MUST_3_WORDS$$'), val => val.split(" ").length >= 3)
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
    });

    async function submitForm() {
        let method = 'POST';
        try {
            await submit(improvementApi, method, newImprovement);
            return true;
        } catch (error) {
            return false;
        }
    }

    async function checkForPossibleMatches() {
        try {
        const response = await get(`${improvementPossibleMatchesApi}?activity_id=${newImprovement.activity}&summary=${newImprovement.value}`);
        const json = await response.json();
        return json
        } catch (err) {
            console.error(err);
        }
    }

    async function saveForm() {
        try {
            await handleDuplicateSearch();
            await validateForm(schema, newImprovement);
            if (formErrors === null){
                await submitForm();
                jQuery('#' + id).modal('hide');
                getIssues();
            }

        } catch (err) {
            if (err.inner) {
                err.inner.forEach((er) => {
                    fieldIsValid[er.path].isValid = false;
                    fieldIsValid[er.path].errors = er.message;
                });
            }
        }
    }

    async function handleDuplicateSearch() {
        formErrors=null
        if (newImprovement.value.split(" ").length >= 3){
            const list = await checkForPossibleMatches()
            if(list.length){
                list.forEach((improvement) => {
                    if (improvement.similarity == 100){
                        formErrors = sgettext('$$DUPLICATE_FOUND$$');
                        return true
                    }
                });
            }
            return false
        }
    }

    async function checkJiraStatus() {
        const response = await get(`${improvementApi}jira_project_configured/?branch_id=${branch}`);
        const json = await response.json();
        return json.enabled
    }

    function resetForm() {
        newImprovement = getDefault()
        fieldIsValid = getDefaultFieldIsValid();
        formErrors = null;
        title = sgettext('$$NEW_IMPROVEMENT$$') + ' ' + details.name;
    }

    async function showImprovementModal() {
        jQuery(`#${id}`).modal('show');
    }

    onMount(async () => {
        await getClassifications();
        jiraStatus = await checkJiraStatus();
        jQuery('#' + id).on('hidden.bs.modal', function() {
            resetForm();
        });
    });

</script>

{#if details}
    {#if $standaloneEdit}
        <div class="title">
            <h3 class="text-primary">
                {details.name}
            </h3>
        </div>
    {/if}
    <h4 transition:fade|local>{sgettext('$$IMPROVEMENTS$$')}</h4>
    <DataTable
        small={false}
        showFooter={data.rows.length > data.per_page}
        footerColSpan={Object.keys(data.columns).length}
        columns={data.columns}
        rows={data.page}
        total={data.rows.length}
        perPage={data.per_page}
        changePage={ (e) => data.page = paginate(data.rows, data.per_page, e.page) }
    />
    {#if showRaiseImprovement}
        <div style="padding-top: 30px">
            <Button
                type="primary"
                on:click={showImprovementModal}
                name={sgettext('$$RAISE_IMPROVEMENT_1$$')}
            ></Button>
        </div>
        <Modal
        {id}
        {title}
        large={true}
        onSave={saveForm}
        >
            <div slot="body" >
                <form>
                    {#if formErrors}
                        <Errors errors={formErrors} />
                    {/if}
                    <div class="form-group">
                        <TextInput
                            id="value"
                            label={sgettext('$$SUMMARY$$')+'*'}
                            bind:value={newImprovement.value}
                            bind:isValid={fieldIsValid.value.isValid}
                            bind:errors={fieldIsValid.value.errors}
                            ignoreFieldLevelValidation={true}
                            multiline={true}
                            {schema}
                        />
                    </div>
                    <div class="form-group">
                        <ComboSelect
                            id="classification"
                            label={sgettext('$$CLASSIFICATION$$')+'*'}
                            bind:options={issueClassificationTypes}
                            bind:value={newImprovement.classification}
                            bind:isValid={fieldIsValid.classification.isValid}
                            bind:errors={fieldIsValid.classification.errors}
                            searchable={false}
                            {schema}
                        />
                    </div>
                </form>
            </div>
        </Modal>
    {/if}
{/if}
